import { LoginComponent } from './pages/login/login.component';
import { ValidationListingComponent } from './pages/validation-listing/validation-listing.component';
import { ValidationDetailComponent } from './pages/validation-detail/validation-detail.component';
import { ApproveValidationComponent } from './pages/approve-validation/approve-validation.component';
import { AdminProductListingComponent } from './pages/admin-product-listing/admin-product-listing.component';
import { ServiceValidationComponent } from './pages/service-validation/service-validation.component';
import { WriteArticleComponent } from './pages/write-article/write-article.component';
import { BusinessValidationComponent } from './pages/business-validation/business-validation.component';

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProductListingComponent } from './pages/product-listing/product-listing.component';

import { SellerApproveComponent } from './pages/seller-approve/seller-approve.component';
import { AppComponent } from './app.component';
import { ValidationPageBComponent } from './pages/validation-page-b/validation-page-b.component';
import { ValidationPageCComponent } from './pages/validation-page-c/validation-page-c.component';
import { AuthGuard } from './auth.guard';
import { ServiceListingComponent } from './pages/service-listing/service-listing.component';
import { LocalBusinessManagerComponent } from './pages/local-business-manager/local-business-manager.component';
import { FaqMasterComponent } from './pages/faq-master/faq-master.component';
import { EntityTypesComponent } from './pages/entity-types/entity-types.component';
import { StateMasterComponent } from './pages/state-master/state-master.component';
import { ValidationDashboardComponent } from './pages/validation-dashboard/validation-dashboard.component';
import { ValidationDashDetailsComponent } from './pages/validation-dash-details/validation-dash-details.component';

const routes: Routes = [
  { component: LoginComponent, path: '' },
  {
    component: ProductListingComponent,
    path: 'product-listing',
    canActivate: [AuthGuard],
  },
  {
    component: ProductListingComponent,
    path: 'approved-product',
    canActivate: [AuthGuard],
    data: {
      approvedOnly: true,
    },
  },
  {
    component: ServiceListingComponent,
    path: 'service-listing',
    canActivate: [AuthGuard],
  },
  {
    component: ServiceListingComponent,
    path: 'approved-services',
    canActivate: [AuthGuard],
    data: {
      approvedOnly: true,
    },
  },
  {
    component: LocalBusinessManagerComponent,
    path: 'local-business',
    canActivate: [AuthGuard],
  },
  {
    component: LocalBusinessManagerComponent,
    path: 'approved-local-business',
    canActivate: [AuthGuard],
    data: {
      approvedOnly: true,
    },
  },
  {
    component: ValidationListingComponent,
    path: 'validation-listing',
  },
  {
    component: ValidationDetailComponent,
    path: 'validation-details/:id/:type',
  },
  {
    component: ValidationPageBComponent,
    path: 'validation-page2',
  },
  {
    component: ValidationPageCComponent,
    path: 'validation-page3',
  },

  {
    component: ApproveValidationComponent,
    path: 'approve-business',
  },

  {
    component: SellerApproveComponent,
    path: 'seller-approve',
  },
  {
    component: AdminProductListingComponent,
    path: 'admin-product-listing',
  },
  {
    component: BusinessValidationComponent,
    path: 'business-validation',
  },
  {
    component: ServiceValidationComponent,
    path: 'service-validation',
  },
  {
    component: WriteArticleComponent,
    path: 'write-article',
  },
  {
    component: FaqMasterComponent,
    path: 'faq-master',
  },
  {
    component: EntityTypesComponent,
    path: 'entity-type',
  },
  {
    component: StateMasterComponent,
    path: 'states',
  },
  {
    component: ValidationDashboardComponent,
    path: 'validate-dash',
  },
  {
    component: ValidationDashDetailsComponent,
    path: 'validate-dash-details/:id/:type',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled', // Add options right here
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
